/**
 * BaB product card selection overlay
 * Toggles .custom-bab-selected when a card quantity is > 0.
 * Also toggles .custom-bab-qty--active on the slideout qty control.
 * Overlay + checkmark are styled in custom-bab-styling.css.
 */
(function () {
  var SELECTED_CLASS = 'custom-bab-selected';
  var QTY_ACTIVE_CLASS = 'custom-bab-qty--active';
  var CARD_SELECTOR = '.bundle-product-card';
  var SLIDE_QTY_SELECTOR =
    '.bundle-slider-footer .bundle-product-card__quantity-button-container';

  function getCardQuantity(card) {
    var q = card.getAttribute('data-quantity');
    if (q !== null && q !== undefined && q !== '') {
      return parseInt(q, 10) || 0;
    }

    var qClass = Array.prototype.find.call(card.classList, function (name) {
      return /^q_\d+$/.test(name);
    });
    if (qClass) {
      return parseInt(qClass.slice(2), 10) || 0;
    }

    var span = card.querySelector('.bundle-product-card__quantity-button-container span');
    if (span) {
      return parseInt(span.textContent, 10) || 0;
    }

    return 0;
  }

  function getQtyFromContainer(container) {
    var span = container.querySelector('span');
    return span ? parseInt(span.textContent, 10) || 0 : 0;
  }

  function syncCard(card) {
    card.classList.toggle(SELECTED_CLASS, getCardQuantity(card) > 0);
  }

  function syncSlideQty(container) {
    container.classList.toggle(QTY_ACTIVE_CLASS, getQtyFromContainer(container) > 0);
  }

  function syncAll(root) {
    var scope = root || document;
    scope.querySelectorAll(CARD_SELECTOR).forEach(syncCard);
    scope.querySelectorAll(SLIDE_QTY_SELECTOR).forEach(syncSlideQty);
  }

  function observe() {
    var observer = new MutationObserver(function (mutations) {
      var needsFullSync = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches(CARD_SELECTOR)) {
              syncCard(node);
            } else if (node.matches && node.matches(SLIDE_QTY_SELECTOR)) {
              syncSlideQty(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll(CARD_SELECTOR).forEach(syncCard);
              node.querySelectorAll(SLIDE_QTY_SELECTOR).forEach(syncSlideQty);
            }
          });
          needsFullSync = true;
        }

        if (mutation.type === 'attributes' && mutation.target) {
          var card =
            mutation.target.closest && mutation.target.closest(CARD_SELECTOR);
          if (card) syncCard(card);

          var slideQty =
            mutation.target.closest && mutation.target.closest(SLIDE_QTY_SELECTOR);
          if (slideQty) syncSlideQty(slideQty);
        }

        if (mutation.type === 'characterData') {
          var parent = mutation.target.parentElement;
          if (!parent) return;

          var textCard = parent.closest(CARD_SELECTOR);
          if (textCard) syncCard(textCard);

          var textSlideQty = parent.closest(SLIDE_QTY_SELECTOR);
          if (textSlideQty) syncSlideQty(textSlideQty);
        }
      });

      if (needsFullSync) syncAll();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-quantity', 'disabled'],
      characterData: true,
    });
  }

  function init() {
    syncAll();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
